
  (function initDualModeSlider() {
    const slider = document.getElementById('dual-mode-slider');
    const cardMotorcycle = document.getElementById('card-motorcycle');
    const cardBicycle = document.getElementById('card-bicycle');
    const cardsContainer = document.getElementById('cards-container');
    if (!slider) return;

    let isDragging = false;
    let currentPos = 50; // 0 to 100
    let rafId = null;

    function updateCards(sliderPositionNormalized) {
      if (!cardMotorcycle || !cardBicycle) return;
      const pos = Math.max(0, Math.min(1, sliderPositionNormalized));
      const isDesktop = window.innerWidth >= 768;

      if (!isDesktop) {
        cardMotorcycle.style.transform = '';
        cardMotorcycle.style.opacity = '1';
        cardMotorcycle.style.zIndex = '1';
        cardBicycle.style.transform = '';
        cardBicycle.style.opacity = '1';
        cardBicycle.style.zIndex = '1';
        return;
      }

      // Base translation offset to center in a 2-column flex/grid container:
      // Left column center is at 25% of container width; moving to 50% requires +25% of container width (which is +50% of the card's own width if card is 50% container width).
      if (pos > 0.5) {
        // Dragging Right -> Motorcycle expands & centers; Bicycle fades & shrinks
        const rightProgress = Math.max(0, Math.min(1, (pos - 0.5) * 2));
        const motoScale = 1.0 + (0.2 * rightProgress);
        const motoOpacity = 1.0;
        const motoTranslateX = (50 * rightProgress); // % of card width toward center

        const bikeScale = 1.0 - (0.3 * rightProgress);
        const bikeOpacity = Math.max(0, 1.0 - rightProgress);

        cardMotorcycle.style.transform = `translateX(${motoTranslateX}%) scale(${motoScale})`;
        cardMotorcycle.style.opacity = motoOpacity;
        cardMotorcycle.style.zIndex = '10';

        cardBicycle.style.transform = `scale(${bikeScale})`;
        cardBicycle.style.opacity = bikeOpacity;
        cardBicycle.style.zIndex = '1';
        cardBicycle.style.pointerEvents = rightProgress > 0.85 ? 'none' : 'auto';
        cardMotorcycle.style.pointerEvents = 'auto';
      } else if (pos < 0.5) {
        // Dragging Left -> Bicycle expands & centers; Motorcycle fades & shrinks
        const leftProgress = Math.max(0, Math.min(1, (0.5 - pos) * 2));
        const bikeScale = 1.0 + (0.2 * leftProgress);
        const bikeOpacity = 1.0;
        const bikeTranslateX = -(50 * leftProgress); // % of card width toward center

        const motoScale = 1.0 - (0.3 * leftProgress);
        const motoOpacity = Math.max(0, 1.0 - leftProgress);

        cardBicycle.style.transform = `translateX(${bikeTranslateX}%) scale(${bikeScale})`;
        cardBicycle.style.opacity = bikeOpacity;
        cardBicycle.style.zIndex = '10';

        cardMotorcycle.style.transform = `scale(${motoScale})`;
        cardMotorcycle.style.opacity = motoOpacity;
        cardMotorcycle.style.zIndex = '1';
        cardMotorcycle.style.pointerEvents = leftProgress > 0.85 ? 'none' : 'auto';
        cardBicycle.style.pointerEvents = 'auto';
      } else {
        // cardMotorcycle.style.transform = 'translateX(0) scale(1)';
        cardMotorcycle.style.opacity = '1';
        cardMotorcycle.style.zIndex = '2';
        cardMotorcycle.style.pointerEvents = 'auto';

        cardBicycle.style.transform = 'translateX(0) scale(1)';
        cardBicycle.style.opacity = '1';
        cardBicycle.style.zIndex = '2';
        cardBicycle.style.pointerEvents = 'auto';
      }
    }

    function setPosition(percent) {
      currentPos = Math.max(0, Math.min(100, percent));
      slider.style.setProperty('--slider-pos', currentPos + '%');
      slider.setAttribute('aria-valuenow', Math.round(currentPos));
      updateCards(currentPos / 100);
    }

    function updateFromPointer(clientX) {
      const rect = slider.getBoundingClientRect();
      const x = clientX - rect.left;
      const percent = (x / rect.width) * 100;
      setPosition(percent);
    }

    function onPointerDown(e) {
      isDragging = true;
      updateFromPointer(e.clientX || (e.touches && e.touches[0].clientX));
      slider.style.cursor = 'ew-resize';
      document.body.style.userSelect = 'none';
    }

    function onPointerMove(e) {
      if (!isDragging) return;
      const clientX = e.clientX || (e.touches && e.touches[0].clientX);
      if (clientX !== undefined) {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          updateFromPointer(clientX);
        });
      }
    }

    function onPointerUp() {
      if (isDragging) {
        isDragging = false;
        slider.style.cursor = '';
        document.body.style.userSelect = '';
        if (rafId) cancelAnimationFrame(rafId);
      }
    }

    // Mouse events
    slider.addEventListener('mousedown', onPointerDown);
    window.addEventListener('mousemove', onPointerMove, { passive: true });
    window.addEventListener('mouseup', onPointerUp);

    // Touch events
    slider.addEventListener('touchstart', onPointerDown, { passive: true });
    window.addEventListener('touchmove', onPointerMove, { passive: true });
    window.addEventListener('touchend', onPointerUp);
    window.addEventListener('touchcancel', onPointerUp);

    // Responsive recalculation
    window.addEventListener('resize', () => {
      updateCards(currentPos / 100);
    });

    // Keyboard accessibility
    slider.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        setPosition(currentPos - 5);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        setPosition(currentPos + 5);
      } else if (e.key === 'Home') {
        e.preventDefault();
        setPosition(0);
      } else if (e.key === 'End') {
        e.preventDefault();
        setPosition(100);
      }
    });

    // Initial hint animation (subtle cue from 45% to 50%)
    let startAnimTime = null;
    function animateCue(timestamp) {
      if (!startAnimTime) startAnimTime = timestamp;
      const elapsed = timestamp - startAnimTime;
      const duration = 700;
      if (elapsed < duration) {
        const progress = elapsed / duration;
        const ease = 0.5 - Math.cos(progress * Math.PI) / 2;
        setPosition(45 + ease * 5);
        requestAnimationFrame(animateCue);
      } else {
        setPosition(50);
      }
    }
    setTimeout(() => {
      requestAnimationFrame(animateCue);
    }, 400);

    // Initialize layout immediately
    setPosition(50);
  })();


  (function initSpecModal() {
    const triggerBtn = document.getElementById('spec-modal-trigger');
    const modal = document.getElementById('spec-modal');
    const backdrop = document.getElementById('spec-modal-backdrop');
    const closeBtn = document.getElementById('spec-modal-close');
    const card = document.getElementById('spec-modal-card');

    if (!modal || !triggerBtn) return;

    let savedScrollY = 0;

    function openModal(e) {
      if (e) e.preventDefault();
      savedScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.overflow = 'hidden';
      modal.classList.remove('opacity-0', 'pointer-events-none');
      modal.classList.add('opacity-100', 'pointer-events-auto');
      if (card) {
        card.classList.remove('translate-y-4');
        card.classList.add('translate-y-0');
      }
    }

    function closeModal(e) {
      if (e) e.preventDefault();
      document.body.style.overflow = '';
      modal.classList.remove('opacity-100', 'pointer-events-auto');
      modal.classList.add('opacity-0', 'pointer-events-none');
      if (card) {
        card.classList.remove('translate-y-0');
        card.classList.add('translate-y-4');
      }
      window.scrollTo({ top: savedScrollY, behavior: 'instant' });
    }

    triggerBtn.addEventListener('click', openModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !modal.classList.contains('pointer-events-none')) {
        closeModal(e);
      }
    });
  })();
